// eslint-disable-next-line @typescript-eslint/no-unused-vars
import MyLocale from '@/models/MyLocale.model';
import { createI18n } from 'vue-i18n';
import { LocaleEnum } from '@/enums/Locale.enum';
import { rs } from '@/localization/rs.locale';
import { gb } from '@/localization/gb.locale';
import { ba } from '@/localization/ba.locale';
import { mk } from '@/localization/mk.locale';
import { al } from '@/localization/al.locale';
import { me } from '@/localization/me.locale';
import { hr } from '@/localization/hr.locale';

const messages = {
	[LocaleEnum.GB]: gb,
	[LocaleEnum.RS]: rs,
	[LocaleEnum.BA]: ba,
	[LocaleEnum.MK]: mk,
	[LocaleEnum.AL]: al,
  [LocaleEnum.ME]: me,
  [LocaleEnum.HR]: hr,
} as const;

export const DEFAULT_LOCAL = process.env.VUE_APP_DEFAULT_LOCAL || LocaleEnum.GB;

export const i18n = createI18n({
	legacy: false, // Use legacy mode for better compatibility
	locale: DEFAULT_LOCAL,
	fallbackLocale: LocaleEnum.GB,
	warnHtmlInMessage: 'off',
	messages: messages as any,
	silentTranslationWarn: true,
	silentFallbackWarn: true,
	missingWarn: false,
	fallbackWarn: false,
});
